import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import {
  AdvancedDatasetOrCurrentPeopleFilterContextProvider,
  useAdvancedDatasetOrCurrentPeopleFilter,
} from 'views/Widgets/Filters/AdvancedSpecializedFilter';

interface Props {
  isDemoMode: boolean;
}

const FIELD_LEGACY = 'filters';
const FIELD_RECEIVER = 'filters_receiver';

const IncludeExcludeFilterDescriptor: FC<Props> = (props: Props) => {
  // Hack to get it only from the preview path
  const { campaignId } = useParams<{ campaignId?: string }>();

  const filterDescription = (filter) => {
    if (filter._index.startsWith('below_')) {
      return filter.description;
    }
    return filter.name;
  };

  function formatFilter(it) {
    return filterDescription(it);
  }

  if (!props.isDemoMode || !campaignId) {
    return null;
  }

  const hasIncludeFilters = (props?.[FIELD_LEGACY]?.include ?? []).length > 0;

  const hasExcludeFilters = (props?.[FIELD_LEGACY]?.exclude ?? []).length > 0;

  const hasLegacyIncludeExcludeFilters = hasIncludeFilters || hasExcludeFilters;

  const hasReceiverAdvancedFilters =
    props?.[FIELD_RECEIVER] && Object.keys(props[FIELD_RECEIVER]).length > 0;

  if (!hasLegacyIncludeExcludeFilters && !hasReceiverAdvancedFilters) {
    return null;
  }

  return (
    <>
      <br />{' '}
      {hasLegacyIncludeExcludeFilters && (
        <div
          data-testid="filter-description"
          className="badge bg-light mb-2 text-wrap"
        >
          {hasIncludeFilters && (
            <span>
              <FormattedMessage
                id="app.widgets.people.filters.include_exclude_filter_descriptor.this_question_will_only_show"
                defaultMessage="This question will only show for"
                description="Text for the include filter which is followed by a list"
              />{' '}
              <b>
                {props?.[FIELD_LEGACY].include.map(formatFilter).join(', ')}
                {'. '}
              </b>
            </span>
          )}
          <span> </span>
          {hasExcludeFilters && (
            <span>
              <FormattedMessage
                id="app.widgets.people.filters.include_exclude_filter_descriptor.this_question_will_not_show"
                defaultMessage="This question will not show for"
                description="Text for the exclude filter which is followed by a list"
              />{' '}
              <b>
                {props?.[FIELD_LEGACY].exclude.map(formatFilter).join(', ')}
                {'.'}
              </b>
            </span>
          )}
        </div>
      )}
      {/* The legacy always take precedence */}
      {hasReceiverAdvancedFilters && !hasLegacyIncludeExcludeFilters && (
        <AdvancedDatasetOrCurrentPeopleFilterContextProvider
          roleScope="SYSTEM_ADMIN"
          campaignId={Number(campaignId)}
          includeHierarchyFilters={false}
        >
          <AdvancedIncludeExcludeFilterDescriptor
            filters={props[FIELD_RECEIVER]}
          />
        </AdvancedDatasetOrCurrentPeopleFilterContextProvider>
      )}
    </>
  );
};

const AdvancedIncludeExcludeFilterDescriptor = ({ filters }) => {
  const { filterToText } = useAdvancedDatasetOrCurrentPeopleFilter();

  return (
    <div
      data-testid="filter-receiver-description"
      className="badge bg-light mb-2 text-wrap"
    >
      <span>
        <FormattedMessage
          id="app.widgets.people.filters.include_exclude_filter_target_descriptor.this_question_will_only_show"
          defaultMessage="Only shown if the subject of the question {matchCondition}"
          values={{
            matchCondition: <b>{filterToText(filters)}</b>,
          }}
        />
      </span>
    </div>
  );
};

export default IncludeExcludeFilterDescriptor;
